import moment from 'moment'
import { EnumPeriodoLiquidacion } from '../../../api'
import { PriceCoefficientTable } from '../../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'
import { GridRows } from '../../../helpers/gridValuesGenerator/gridValuesGenerator'
import { generateUniqueKeyWithNoPrefix } from '../../../helpers'

export const gridRowToPriceCoefficientList = (
  generatedData: GridRows[],
  settlementPeriod: EnumPeriodoLiquidacion
): PriceCoefficientTable[] => {
  return generatedData.map((item, idx) => {
    let description = ''
    switch (settlementPeriod) {
      case EnumPeriodoLiquidacion.Anual:
        description = `YR-${moment(item.startDate).year()}`
        break
      case EnumPeriodoLiquidacion.Mensual:
        description = `M${moment(item.endDate).month() + 1}-${moment(item.startDate).year()}`
        break
      case EnumPeriodoLiquidacion.Trimestral:
        description = `Q${moment(item.startDate).quarter()}-${moment(item.startDate).year()}`
        break
      default:
        description = `Periodo ${idx}`
    }

    return {
      tempId: generateUniqueKeyWithNoPrefix(),
      periodDescription: description,
      idSettlementPeriod: settlementPeriod,
      startDate: moment(item.startDate).toDate(),
      endDate: moment(item.endDate).toDate(),
      p1: item.quantity,
      p2: item.quantity,
      p3: item.quantity,
      p4: item.quantity,
      p5: item.quantity,
      p6: item.quantity
    } as PriceCoefficientTable
  })
}
